/** W3C Trace Context headers for backend OTEL (traceparent). */

function randomHex(byteLength: number): string {
	if (
		typeof crypto !== "undefined" &&
		typeof crypto.getRandomValues === "function"
	) {
		const bytes = new Uint8Array(byteLength);
		crypto.getRandomValues(bytes);
		return Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
	}
	let out = "";
	for (let i = 0; i < byteLength; i++) {
		out += Math.floor(Math.random() * 256)
			.toString(16)
			.padStart(2, "0");
	}
	return out;
}

/** One trace id per page/session; new span id per outbound request. */
let pageTraceId: string | null = null;

export function createW3CTraceHeaders(): Record<string, string> {
	if (!pageTraceId) {
		pageTraceId = randomHex(16);
	}
	const spanId = randomHex(8);
	return {
		traceparent: `00-${pageTraceId}-${spanId}-01`,
	};
}

/** W3C trace headers first, then optional extras (e.g. sentry-trace, baggage). */
export function mergeTraceHeaders(
	extra?: Record<string, string>,
): Record<string, string> {
	const merged = { ...createW3CTraceHeaders() };
	if (extra) {
		for (const [key, value] of Object.entries(extra)) {
			if (value) {
				merged[key] = value;
			}
		}
	}
	return merged;
}

/** Test helper — reset session trace id between tests. */
export function resetW3CTraceSessionForTests(): void {
	pageTraceId = null;
}
